
import React from "react"; 
import { Component } from "react";

class Header extends Component {
    render() {
        return (
            <div className="navbar bg-dark rounded text-white">
                <h1>Team Works</h1>
            </div>
        )
    }
}

export default Header;

